import { render, staticRenderFns } from "./SpecialItem.vue?vue&type=template&id=6a13606c"
import script from "./SpecialItem.vue?vue&type=script&lang=js"
export * from "./SpecialItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports